// @flow

import {observer} from 'mobx-react';
import React  from 'react';
// React Syntax Highlighter - Light Build
// https://github.com/conorhastings/react-syntax-highlighter#light-build
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-light';
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript';
import atomdark from 'react-syntax-highlighter/dist/esm/styles/prism/atom-dark';
// "tomorrow" & "xonokai" are also fair looking styles

SyntaxHighlighter.registerLanguage('javascript', javascript);

type Props = {
  children: string
}

const Code = observer((props: Props) => (
  <SyntaxHighlighter
    language="javascript"
    style={atomdark}
    customStyle={{
      'lineHeight': '1'
    }}
  >
    {props.children}
  </SyntaxHighlighter>
));

export default Code;
